import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.less';
import reportWebVitals from './reportWebVitals';
import './theme/DarkTheme.css';
import './theme/LightTheme.css';
import './theme/SizeTheme.less';

const rootElement = document.getElementById('root') as HTMLElement;
rootElement.classList.add('Dark');
const root = ReactDOM.createRoot(rootElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
